module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "textComment"
  }, [_c('el-breadcrumb', {
    staticClass: "bread-nav",
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("首页")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("互动直播")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("评论管理")])], 1), _vm._v(" "), _c('div', {
    staticClass: "commentLeft"
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择执行（非必选）"
    },
    on: {
      "change": function($event) {
        _vm.changeCreator()
      }
    },
    model: {
      value: (_vm.creator),
      callback: function($$v) {
        _vm.creator = $$v
      },
      expression: "creator"
    }
  }, _vm._l((_vm.userList), function(item) {
    return _c('el-option', {
      key: item.userId,
      attrs: {
        "label": item.userName,
        "value": item.userId
      }
    })
  })), _vm._v(" "), _c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择直播"
    },
    on: {
      "change": function($event) {
        _vm.changeLive(_vm.liveValue)
      }
    },
    model: {
      value: (_vm.liveValue),
      callback: function($$v) {
        _vm.liveValue = $$v
      },
      expression: "liveValue"
    }
  }, _vm._l((_vm.filterCreator), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.liveTitle,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "commentRight"
  }, [_c('ul', {
    staticClass: "commentList"
  }, _vm._l((_vm.liveCommentList), function(item, index) {
    return _c('li', {
      key: item.id
    }, [_c('div', {
      staticClass: "commentText"
    }, [_vm._v(_vm._s(item.content))]), _vm._v(" "), _c('div', {
      staticClass: "commentTime"
    }, [_vm._v(_vm._s(item.createTime) + "\n          "), _c('el-button', {
      attrs: {
        "type": "danger",
        "size": "mini",
        "icon": "delete"
      },
      on: {
        "click": function($event) {
          _vm.deleteComment(item, index)
        }
      }
    })], 1)])
  }))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-3d8d3b8c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/content/ugclive/Comment.vue
// module id = 756
// module chunks = 1